import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { ITableColumn } from 'app/main/shared/shared/table/table-column';
import { IPlaybooksItemDTO } from '../../../dto/playbooks-listening.dto';

@Component({
  selector: 'app-playbook-category',
  standalone: true,
  imports: [
    CommonModule
  ],
  templateUrl: './playbook-category.component.html',
  styleUrl: './playbook-category.component.scss'
})
export class PlaybookCategoryComponent {
    @Input() dataItem: IPlaybooksItemDTO;
    @Input() columnOptions: ITableColumn;
}
